export type AccomodationFieldType = {
  _id?: string;
  accomodationManagement: string;
  accomodationManagementObs: string;
  responsibleContact: string[];
  responsibleAgency: string[];
  accomodationUpgrades: string;
  upgradeValues: UpgradeValue;
  contactToggle: boolean;
  hotelToggle: boolean;
};

type UpgradeValuesFields = {
  description: string;
  valueType: string;
  obs: string;
};

type UpgradeValue = {
  aptSingle: UpgradeValuesFields;
  aptDouble: UpgradeValuesFields;
  aptTriple: UpgradeValuesFields;
  proDouble: UpgradeValuesFields;
  singleTriple: UpgradeValuesFields;
  extraBed: UpgradeValuesFields;
  cradle: UpgradeValuesFields;
  policyForChildren: UpgradeValuesFields;
  test: any;
};

export enum ResponsibleContactEnum {
  RESPONSIBLE_DATA = "Dados do Responsável",
  NAME = "Nome",
  PHONE = "Fone",
  EMAIL = "E-mail",
}

export enum ResponsibleAgencyEnum {
  OFFICIAL_AGENCY = "Agência oficial",
  HOTEL = "Hotel",
}
